'use client';
import { FileText } from 'lucide-react';
import UploadBanner from './UploadBanner';

export default function DashboardEmptyState() {
  return (
    <div className="card-elevated flex flex-col items-center gap-6 py-16 px-6 text-center">
      <div className="w-20 h-20 rounded-2xl bg-secondary flex items-center justify-center">
        <FileText size={36} className="text-primary" />
      </div>
      <div className="max-w-md">
        <h2 className="text-xl font-700 text-foreground mb-2">Build your certificate dashboard</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Upload your DG Shipping profile PDF to automatically import all your certificates,
          sea service, and training records in one shot — no manual entry needed.
        </p>
      </div>
      <UploadBanner />
    </div>
  );
}
